export enum Department {
    SMILE_TEAM_360 = 'Smile Team 360',
    KEY = 'KEY',
    FD = 'FD'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/department-type.enum.ts